<template>
  <div class="ol-titulo">
    <span v-if="rotulo" class="ol-titulo__numero">{{ rotulo }}</span>
    <span class="ol-titulo__nome">
      {{ nome }}<b v-if="obrigatorio" class="ol-titulo__obrigatorio" title="Obrigatória">*</b>
    </span>
  </div>
</template>

<script>
// Título padrão das perguntas: número num selo separado do texto (antes ficava
// colado: "1-2Nome") e o asterisco de obrigatória junto do nome.
export default {
  name: 'TituloQuestao',

  props: {
    // Como o Checklist calcula ("1-", "1-2"); o hífen final some na exibição.
    numero: {
      type: String,
      default: null,
    },
    nome: {
      type: String,
      default: '',
    },
    obrigatorio: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    rotulo() {
      return this.numero ? String(this.numero).replace(/-$/, '') : '';
    },
  },
};
</script>

<style scoped>
.ol-titulo {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  line-height: 1.35;
}

.ol-titulo__numero {
  flex-shrink: 0;
  min-width: 34px;
  padding: 2px 8px;
  margin-top: 1px;
  border-radius: 6px;
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #a5d6a7;
  font-size: 0.85rem;
  font-weight: 700;
  text-align: center;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}

.ol-titulo__nome {
  min-width: 0;
  word-break: normal;
  overflow-wrap: break-word;
}

.ol-titulo__obrigatorio {
  color: red;
  padding-left: 4px;
}
</style>
